// Footer.jsx
import { Link } from 'react-router-dom';
import { FaTruck, FaFacebookF, FaInstagram, FaWhatsapp, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { COMPANY } from '../../data/siteData';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <FaTruck className="footer__silhouette" aria-hidden="true" />
      <div className="container footer__grid">
        <div>
          <Link to="/" className="footer__logo">
            Ambadykannan <em>Transport</em>
          </Link>
          <p className="footer__tagline">{COMPANY.tagline}</p>
          {/* <div className="footer__socials">
            <a href="#" aria-label="Facebook"><FaFacebookF /></a>
            <a href="#" aria-label="Instagram"><FaInstagram /></a>
            <a href={`https://wa.me/${COMPANY.whatsapp}`} aria-label="WhatsApp"><FaWhatsapp /></a>
          </div> */}
        </div>

        <div>
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4>Services</h4>
          <ul>
            <li>Truck Transport</li>
            <li>Lorry Transport</li>
            <li>Construction Material</li>
            <li>Long Distance Freight</li>
          </ul>
        </div>

        <div>
          <h4>Contact</h4>
          <ul className="footer__contact">
            <li><FaPhoneAlt /> {COMPANY.phone}</li>
            <li><FaEnvelope /> {COMPANY.email}</li>
            <li><FaMapMarkerAlt /> {COMPANY.address}</li>
          </ul>
        </div>
      </div>

      <div className="footer__bottom container">
        <p>&copy; {new Date().getFullYear()} Ambadykannan Transport. All rights reserved.</p>
        {/* <p className="footer__credit">Designed with premium animation.</p> */}
        <p className="footer__credit">Developed by <a href='https://mpeoples.in/' target='_blank'> Mpeoples Business Solutions Pvt Ltd </a></p>
      </div>
    </footer>
  );
}